import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useNavigate, useParams } from "react-router-dom";
import { LoadingPanel } from "../../../components/layout/Loading";
import { Typography } from "@progress/kendo-react-common";
import { Button } from "@progress/kendo-react-buttons";
import { getInquiryReport } from "../services/reports.services";
import { checkAcessRights } from "../../../_helper/helper";
import { EXCEL_EXPORT_ACCESS, PRINT_ACCESS } from "../../../_contstants/common";
import AlertBox from "../../../components/common/AlertBox";
import moment from "moment";

const InquiryReportView = () => {
  const gridRef = React.useRef<any>(null);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const isExcelExportAccess = checkAcessRights(
    "/inquiryreportform",
    EXCEL_EXPORT_ACCESS
  );
  const isPrintAccess = checkAcessRights("/inquiryreportform", PRINT_ACCESS);

  const filterFromDate = params?.filterFromDate;
  const filterToDate = params?.filterToDate;
  const filterRequirementType = params?.filterRequirementType;
  const filterDestination = params?.filterDestination;
  const filterInquiryStageID = params?.filterInquiryStageID;
  const filterInquiryStatus = params?.filterInquiryStatus;
  const filterInquirySourceID = params?.filterInquirySourceID;
  const filterAssignedTo = params?.filterAssignedTo;

  const loading = useAppSelector((state) => state.reports.loading);
  const InquiryListForReport = useAppSelector(
    (state) => state.reports.InquiryListForReport
  );

  const [uiLoading, setLoading] = React.useState<boolean>(true);

  useEffect(() => {
    setLoading(loading);
  }, [loading]);

  useEffect(() => {
    if (filterToDate && filterFromDate) {
      const payload = {
        filterFromDate: filterFromDate !== "0" ? filterFromDate : "",
        filterToDate: filterToDate !== "0" ? filterToDate : "",
        filterRequirementType:
          filterRequirementType !== "0" ? filterRequirementType : "",
        filterDestination: filterDestination !== "0" ? filterDestination : 0,
        filterInquiryStageID:
          filterInquiryStageID !== "0" ? filterInquiryStageID : 0,
        filterInquiryStatus:
          filterInquiryStatus !== "0" ? filterInquiryStatus : "",
        filterInquirySourceID:
          filterInquirySourceID !== "0" ? filterInquirySourceID : 0,
        filterAssignedTo: filterAssignedTo !== "0" ? filterAssignedTo : 0,
      };
      dispatch(getInquiryReport(payload));
    }
  }, []);

  const handleExportExcel = () => {
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.table_to_sheet(
      document.querySelector(".table-bordered")
    );
    XLSX.utils.book_append_sheet(wb, ws, "InquiryReport");

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(data, "inquiryreport.xlsx");
  };

  const handleEdit = (data: any) => {
    navigate("/inquiry/edit", {
      state: {
        InquiryID: data?.ID,
        RequirementType: data?.RequirementType,
      },
    });
  };

  if (uiLoading) return <LoadingPanel gridRef={gridRef} />;
  return (
    <>
      <div
        className="report-container"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "20px 10px",
        }}
      >
        <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
          Inquiry Report{" "}
          <span style={{ fontSize: 15 }}>
            {InquiryListForReport &&
              InquiryListForReport.length > 0 &&
              `(
              ${
                filterFromDate !== "0"
                  ? moment(filterFromDate, "YYYY-MM-DD").format("DD/MM/YYYY")
                  : ""
              }${filterFromDate !== "0" && filterToDate !== "0" ? " to " : ""}${
                filterToDate !== "0"
                  ? moment(filterToDate, "YYYY-MM-DD").format("DD/MM/YYYY")
                  : " "
              }
              )`}
          </span>
        </Typography.h4>
        <div className="printbuttons">
          {isPrintAccess &&
            InquiryListForReport &&
            InquiryListForReport.length > 0 && (
              <Button
                style={{ marginRight: 5 }}
                type="button"
                fillMode={"solid"}
                themeColor={"primary"}
                onClick={() => window.print()}
              >
                Print
              </Button>
            )}

          {isExcelExportAccess &&
            InquiryListForReport &&
            InquiryListForReport.length > 0 && (
              <Button
                type="button"
                fillMode={"solid"}
                themeColor={"primary"}
                onClick={handleExportExcel}
              >
                Excel Export
              </Button>
            )}
        </div>
      </div>
      {InquiryListForReport && InquiryListForReport.length > 0 ? (
        <div className="table-responsive" style={{ margin: "0 10px" }}>
          <table className="table table-bordered reportScreens lead-report">
            <thead>
              <tr>
                <th style={{ background: "black", color: "white" }}>No</th>
                <th style={{ background: "black", color: "white" }}>
                  Inquiry Date
                </th>
                <th style={{ background: "black", color: "white" }}>Name</th>
                <th style={{ background: "black", color: "white" }}>
                  Mobile No
                </th>
                <th style={{ background: "black", color: "white" }}>Type</th>
                <th style={{ background: "black", color: "white" }}>
                  Destination
                </th>
                <th style={{ background: "black", color: "white" }}>
                  Inquiry Status
                </th>
                <th style={{ background: "black", color: "white" }}>
                  Inquiry Source
                </th>
                <th style={{ background: "black", color: "white" }}>
                  Assigned User
                </th>
              </tr>
            </thead>
            <tbody>
              {InquiryListForReport &&
                InquiryListForReport.length > 0 &&
                InquiryListForReport?.map((inquiry: any, index: number) => (
                  <tr>
                    <td className="text-center">{index + 1}</td>
                    <td className="text-center">
                      {inquiry?.InquiryDate
                        ? moment(inquiry?.InquiryDate, "DD/MM/YYYY").format(
                            "DD MMM YYYY"
                          )
                        : ""}
                    </td>
                    <td
                      className="hoverableName"
                      onClick={() => handleEdit(inquiry)}
                    >
                      {inquiry?.Initial +
                        " " +
                        inquiry?.FirstName +
                        " " +
                        inquiry?.LastName}
                    </td>
                    <td className="text-center">{inquiry?.MobileNo || ""}</td>
                    <td className="text-center">
                      {inquiry?.RequirementType || ""}
                    </td>
                    <td>{inquiry?.Destination || ""}</td>
                    <td className="text-center">
                      {inquiry?.InquiryType || ""}
                    </td>
                    <td className="text-center">
                      {inquiry?.InquirySource || ""}
                    </td>
                    <td>{inquiry?.InquiryOwnerName || ""}</td>
                    {/* <td>{lead?.InquirySource || ""}</td> */}
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      ) : (
        <AlertBox style={{ margin: "0 10px 10px" }} />
      )}
    </>
  );
};

export default InquiryReportView;
